// extracted by mini-css-extract-plugin
export default {"host":"SignupPage_host__BLrGz","loginFormWrapper":"SignupPage_loginFormWrapper__rQy6h","loginForm":"SignupPage_loginForm__PKBiB","title":"SignupPage_title__+a3WF"};